/**
 * Monta a linha que o aviso de pendência deixa na tramitação local do quadro.
 *
 * A marca sozinha ("Médico avisado…") diz que houve aviso, mas não o que foi dito — e quem lê a
 * tramitação depois precisa saber o que o médico recebeu para não repetir a cobrança nem contradizê-la.
 */

const MARCA_AVISO = 'Médico avisado sobre a pendência.';

/**
 * Texto legível de um corpo de e-mail em HTML.
 *
 * A tramitação guarda texto puro, e o corpo do e-mail é HTML montado a partir de um template. Sem
 * esta conversão a linha viraria uma parede de tags.
 *
 * `<style>` e `<script>` saem INTEIROS, com conteúdo. Apagar só as tags deixava o CSS do template
 * escorrer para dentro do texto — foi o que apareceu na tramitação: o aviso vinha precedido de
 * dezenas de linhas de `@media only screen…`, e a mensagem ao médico se perdia no meio.
 */
export function textoPlanoDeHtml(html: string): string {
    return (html ?? '')
        .replace(/<style\b[^>]*>[\s\S]*?<\/style>/gi, '')
        .replace(/<script\b[^>]*>[\s\S]*?<\/script>/gi, '')
        .replace(/<!--[\s\S]*?-->/g, '')
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<\/p>/gi, '\n')
        .replace(/<[^>]+>/g, '')
        .replace(/&nbsp;/gi, ' ')
        .replace(/&amp;/gi, '&')
        .replace(/&lt;/gi, '<')
        .replace(/&gt;/gi, '>')
        .replace(/&#39;/gi, "'")
        .replace(/&quot;/gi, '"')
        .replace(/\n{3,}/g, '\n\n')
        .trim();
}

/**
 * A linha da tramitação: a marca do evento e o assunto. Duas linhas, no máximo.
 *
 * O CORPO do e-mail não entra aqui. Ele já é guardado como HTML na mesma anotação e a timeline o
 * mostra pelo botão "Ver e-mail enviado", renderizado como o médico o recebeu — repeti-lo em texto
 * era guardar a mesma coisa duas vezes, e era o que fazia o card do histórico crescer por uma tela
 * inteira de mensagem que ninguém lia ali.
 *
 * O assunto fica: é ele que diz QUAL e-mail foi, sem precisar abrir nada.
 */
export function linhaDeTramitacaoDoAviso(assunto: string | undefined): string {
    const assuntoLimpo = (assunto ?? '').trim();
    return assuntoLimpo ? `${MARCA_AVISO}\nAssunto: ${assuntoLimpo}` : MARCA_AVISO;
}
